<template>
    <main class="main publications" tabindex="0">
        <template v-for="(pubs, key, index) in groupedPublications">
            <div :key="'g-' + index" class="publication-group">
                <h2 v-if="key.length > 0">{{ publications.bookstitle }}</h2>
                <h2 v-else>{{ publications.cataloguetitle }}</h2>
                <router-link v-for="(item, index) in pubs" :key="item.uid" :to="{ name: 'publication', params: { id: item.uid } }">
                    <span v-if="key.length == 0" class="indent">{{ index + 1 }}</span><div>{{ item.title }}</div>
                    <img v-if="item.preview" class="publication-preview" :style="`top: ${y}px; left: ${x}px`" :class="{'bottom': bottom }" :src="item.preview.url" alt="cover">
                </router-link>
            </div>
        </template>
    </main>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "publications",
    metaInfo() {
        return {
        title: "- Publications"
        };
    },
    data() {
        return {
            x: 0,
            y: 0,
            show: false,
            bottom: false,
        };
    },
    mounted(){
        window.addEventListener("mousemove", this.handleMouseMove);
    },
    beforeDestroy() {
        window.removeEventListener("mousemove", this.handleMouseMove);
    },
    computed: {
        ...mapState(["publications"]),
        groupedPublications() {
            let groups = this.publications.items.data.reduce((acc, item) => {
                let key = item.category;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});   
            // make sure the key without any value is at the beginning
            if (groups[""]) {
                const empty = groups[""];
                delete groups[""];
                groups = { "": empty, ...groups };
            }
            return groups;
        }
    },
    methods: {
        handleMouseMove(e) {
            this.x = e.clientX;
            this.y = e.clientY;
            if(this.y > window.innerHeight * 0.5) {
                this.bottom = true;
            } else {
                this.bottom = false;
            }
        },
        closeToBottom() {
            return true;
            // return this.y > window.innerHeight * 0.75;
        }
    }
};
</script>

<style lang="scss" scoped>
.publications {
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-y:auto;
    .publication-group {
        margin-bottom: var(--lh);
    }
    h2 {
        margin-bottom:0;
    }
}
a {
  display: flex;
  position:relative;
  &:hover {
    .publication-preview {
        display: block;
        @media only screen and (max-width: 768px) {
            display: none;
        }
    }
  }
  .publication-preview {
    position:fixed;
    display:none;
    pointer-events: none;
    transform: translate(1rem, 1rem);
    width:15ch;
    z-index:999;
    &.bottom {
        transform: translate(1rem, -100%);
    }
    
  }
}
.indent {
  width: 3ch;
  flex:0 0 auto;
  display: inline-block;
  @media only screen and (max-width: 768px) {
    width: 3ch;
  }
}
.indent + div {
    display:inline-block;
}
</style>
